import journeyClient from '@/axiosClients/journeyClient'

const journeyService = {
  /** Solo daily_meditation (equivalente al bloque de resources/home). */
  getDailyMeditationResource: () =>
    journeyClient.get('/resilience/v1/content/resources/daily-meditation'),

  getDailyMeditation: (dailyMeditationId) =>
    journeyClient.get(`/resilience/v1/content/daily-meditations/${dailyMeditationId}`),

  toggleFavorite: (contentType, contentId, isFavorite) =>
    journeyClient.post('/resilience/v1/favorites/', {
      content_type: contentType === 'course' ? 'challenge' : contentType,
      content_id: contentId,
      is_favorite: isFavorite,
    }),

  saveAudioProgress: (audioId, lastPositionSeconds, isCompleted, challengeDayStepId = null) =>
    journeyClient.post(
      `/resilience/v1/progress/audios/${audioId}/playback-sessions`,
      {
        last_position_seconds: lastPositionSeconds,
        is_completed: isCompleted,
        challenge_day_step_id: challengeDayStepId,
      }
    ),
}

export default journeyService
